export const getSearchRequestConfig = (): RequestInit => ({ headers: { "Client-Identifier": "libry-content" } });

export const searchParameterName = "s";

export const defaultSizes = {
  works: 9,
  content: 4,
  agents: 4,
};
